import { defineStore } from "pinia";
import type { Client, HistoryRoute } from "~/types";

export type SignInDialogStep = "phone";

export const useGlobalStore = defineStore("globalStore", () => {
  const headerHeight = ref(120);
  const isLoading = ref(false);
  const progress = ref(false);
  const historyStack = ref<HistoryRoute[]>([]);
  const preRoute = ref<HistoryRoute | undefined>(undefined);
  const isLocationChanged = ref(false);
  const isClientBlocked = ref(false);
  const goingToSignInFromRoute = ref<string | null>(null);

  // Sign-in dialog (modal-based replacement for /sign-in redirects on location pages).
  const signInModalOpen = ref(false);
  const signInModalStep = ref<SignInDialogStep>("phone");
  const signInModalOnSuccess = ref<((c: Client) => void) | null>(null);

  function openSignInModal(opts?: {
    step?: SignInDialogStep;
    onSuccess?: (c: Client) => void;
  }) {
    signInModalStep.value = opts?.step ?? "phone";
    signInModalOnSuccess.value = opts?.onSuccess ?? null;
    signInModalOpen.value = true;
  }

  function closeSignInModal() {
    signInModalOpen.value = false;
    signInModalOnSuccess.value = null;
  }

  return {
    headerHeight,
    isLoading,
    progress,
    historyStack,
    preRoute,
    isLocationChanged,
    isClientBlocked,
    goingToSignInFromRoute,
    signInModalOpen,
    signInModalStep,
    signInModalOnSuccess,
    openSignInModal,
    closeSignInModal,
  }
});
